import cats from './cats.json';

export type Category = {
  name: string;
  title: string;
  text: string;
}

export const CATS = cats as Category[];